import React from 'react';
import styled from '@emotion/styled';
import { css, Theme } from '@emotion/react';
import { rem } from 'polished';
import { motion } from 'framer-motion';
import { animations, spaces } from '../../../core/styles/theme/default';
import { IconSVG } from '../../../primitives';

const StyledWrapper = styled.div(
  ({
    titleLineHeight,
    color,
    theme,
  }: {
    titleLineHeight?: string;
    color?: string;
    theme?: Theme;
  }) => css`
    margin-left: ${rem(spaces.epsilon)};
    margin-right: ${rem(spaces.delta)};
    ${titleLineHeight &&
    css`
      line-height: ${rem(titleLineHeight)};
    `}

    > div {
      display: flex;
    }

    ${color &&
    css`
      svg path {
        stroke: ${color};
      }
    `}

    ${theme?.stylesExtension?.toggleIcon?.icon}
  `,
);

const ToggleIcon = ({
  isExpanded,
  titleLineHeight,
  color,
}: ToggleIconProps) => {
  return (
    <StyledWrapper titleLineHeight={titleLineHeight} color={color}>
      <motion.div
        animate={{ rotate: isExpanded ? 180 : 0 }}
        transition={{ duration: animations.durationDefault }}
        style={{ originX: '50%', originY: '50%' }}
      >
        <IconSVG iconName="EchIconDown" iconSize="32" />
      </motion.div>
    </StyledWrapper>
  );
};

type ToggleIconProps = {
  isExpanded?: boolean;
  titleLineHeight?: string;
  color?: string;
};

export default ToggleIcon;
